import {createSelector} from 'reselect';
import {getOptionalPaymentDetailsConsentConfiguration} from './PaymentOptionSelectors';

const getShouldStorePaymentDetails = paymentMethodType => createSelector(
  [getOptionalPaymentDetailsConsentConfiguration],
  optionalPaymentDetailsConsentConfiguration => !!optionalPaymentDetailsConsentConfiguration?.[paymentMethodType],
);

export default getShouldStorePaymentDetails;
